<span
  capraTooltip
  [tooltipIsDisabled]="tooltipIsDisabled"
  [tooltipInteractive]="false"
  [tooltipContent]="dateTooltip"
  [tooltipPlacement]="timestampTooltipPlacement"
  [tooltipSize]="timestampTooltipSize"
  data-test="time-value"
>{{ date | timeAgo: { format: this.format } }}</span>
